// extracted by mini-css-extract-plugin
module.exports = {"container":"_QqVRjbSs","bonusTitle":"_ceRFRoXj","icon":"_WOIENuLO","alertContent":"_-DNnBb2N"};